// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Lm0f","row":"Node_row__1207A","label":"Node_label__HZUzX","footer":"Node_footer__1kk4a"};